import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import Auth0 from '../../../../../../../../store/actions/auth/Auth'
import { toast } from 'react-toastify';

export const getFileList = createAsyncThunk(
  'uploads/getFileList',
  async (data) => {
    const response = await axios.get('/api/admin/deliveries/fromCustomer', {
      params: {
        pageSize: data.pageSize || 25,
        page: (data.pageIndex + 1) || 1
      },
      headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
    });
    return response.data;
  }
);

export const DELETE_UPLOAD_PENDING = 'DELETE_UPLOAD_PENDING';
export const DELETE_UPLOAD_FULFILLED = 'DELETE_UPLOAD_FULFILLED';
export const DELETE_UPLOAD_REJECTED = 'DELETE_UPLOAD_REJECTED';

export const actionCreators = {
  getFileList,
  deleteUpload: (deliveryId) => async (dispatch) => {
    dispatch({
      type: DELETE_UPLOAD_PENDING,
    });
    
    try {
      await axios.delete(`/api/admin/deliveries/fromCustomer/${deliveryId}`, {
        headers: { "Authorization": `Bearer ${Auth0.getAccessToken()}` }
      });
      
      dispatch({
        type: DELETE_UPLOAD_FULFILLED,
        deliveryId: deliveryId,
      });
      
      toast.success('Leveransen har raderats');
    } catch (err) {
      dispatch({
        type: DELETE_UPLOAD_REJECTED,
        error: err
      });
      
      toast.error('Leveransen kunde inte raderas. Kontakta supporten om felet kvarstår.');
    }
  }
};
